// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"888":"77ab36e7","1316":"3b0eddef","3989":"68f0bd1b","6389":"b3446ecb","7433":"936258b2","9791":"c62285b9"}[chunkId] + ".chunk.css";
};